import artIcon from "@assets/icons/activities/art.svg";
import cinemaIcon from "@assets/icons/activities/event_seat.svg";
import gastronomyIcon from "@assets/icons/activities/fork_spoon.svg";
import musicIcon from "@assets/icons/activities/music.svg";
import nightlifeIcon from "@assets/icons/activities/nightlife.svg";
import othersIcon from "@assets/icons/activities/stadium.svg";

// Iconos personalizados de activities
import theaterIcon from "@assets/icons/activities/theater_comedy.svg";
import locationIcon from "@assets/icons/location.svg";
import { useTranslation } from "react-i18next";

export type FilterType = "activity" | "day" | "location" | "combinations";

export interface FilterOption {
  key: string;
  iconSrc?: string;
}

export interface FilterConfig {
  title: string;
  userMessage: string;
  botMessage: string;
  translationKey: string;
  options: FilterOption[];
}

export const useFilterConfig = (filterType: FilterType): FilterConfig => {
  const { t } = useTranslation();

  switch (filterType) {
    case "day":
      return {
        title: t("filter_day.title"),
        userMessage: t("filter_day.user_message"),
        botMessage: t("filter_day.bot_message"),
        translationKey: "filter_day",
        options: [
          { key: "today" },
          { key: "tomorrow" },
          { key: "this_weekend" },
          { key: "next_week" },
          { key: "next_month" }
        ]
      };
    case "location":
      return {
        title: t("filter_location.title"),
        userMessage: t("filter_location.user_message"),
        botMessage: t("filter_location.bot_message"),
        translationKey: "filter_location",
        options: [
          { key: "mi_localizacion", iconSrc: locationIcon },
          { key: "ciutat_vella" },
          { key: "eixample" },
          { key: "sants_montjuic" },
          { key: "les_corts" },
          { key: "sarria_sant_gervasi" },
          { key: "gracia" },
          { key: "horta_guinardo" },
          { key: "nou_barris" },
          { key: "sant_andreu" },
          { key: "sant_marti" }
        ]
      };
    case "combinations":
      // For combinations, we show 3 separate sections (activities, locations, days)
      // This config is only used for title and messages, not for options
      return {
        title: t("filter_combinations.title"),
        userMessage: t("filter_combinations.user_message"),
        botMessage: t("filter_combinations.bot_message"),
        translationKey: "filter_combinations",
        options: [] // Options are handled separately in FilterSectionView
      };
    default:
      return {
        title: t("filter_section.title"),
        userMessage: t("filter_section.user_message"),
        botMessage: t("filter_section.bot_message"),
        translationKey: "filter_section",
        options: [
          { key: "art", iconSrc: artIcon },
          { key: "gastronomy", iconSrc: gastronomyIcon },
          { key: "nightlife", iconSrc: nightlifeIcon },
          { key: "cinema", iconSrc: cinemaIcon },
          { key: "theater", iconSrc: theaterIcon },
          { key: "music", iconSrc: musicIcon },
          { key: "others", iconSrc: othersIcon }
        ]
      };
  }
};
